// extracted by mini-css-extract-plugin
export default {"container":"createAppointment_container__XR69H","wrapper":"createAppointment_wrapper__T-hTa","sections":"createAppointment_sections__GMQ3v"};